import {
  ECustomPackageDealType,
  ECustomPackageOfferType,
  EPackageServiceType,
  EPackageType,
} from '../../../../PayPackageMicrofrontend';

export interface IRecommendedPackageService {
  /** Иконка услуги */
  icon: string;
  /** Тип услуги */
  serviceType: EPackageServiceType;
  /** Название услуги */
  name: string;
  /** Количество объявлений */
  count: number;
  /** Срок действия */
  durationInDays: number;
  /** Количество бонусов */
  auctionPoints: number;
  /** Цена */
  price: number;
  /** Цена до скидки */
  marketingPrice: number;
}

export interface IRecommendedPackage {
  /**
   * Является индексом при поиске выбранного пакета.
   * packageId не может быть индексом, так как среди пакетов с бэка
   * могут быть кастомные пакеты без id и их может быть несколько.
   */
  id: string;
  /** id пакета, нужен бэку при покупке */
  packageId?: number;
  /** автопролонгация */
  autoProlong: boolean;
  /** Признак видимости автопродления */
  autoProlongAvailable: boolean;
  /** Текст заголовка блока рекомендованного пакета */
  headerText: string;
  /** текст хинта блока рекомендованного пакета */
  tooltipText: string;
  /** Длительность пакета в днях */
  durationInDays: number;
  /** Названия регионов действия рекомендованного пакета */
  regionNames: string[];
  /** Название категории в карточке рекомендованного пакета */
  categoriesView: string;
  /** Цена рекомендованного пакета */
  price: number;
  /** Скидка на рекомендованного пакет */
  discountPercent: number;
  /** Цена без скидки */
  marketingPrice: number;
  /** Цена за одно объявление с учетом скидки */
  pricePerOffer: number;
  /** Дата начала действия рекомендованного пакета */
  activationDate: string;
  /** Дата окончания действия рекомендованного пакета */
  endDate: string;
  /** Общее количество объявлений в рекомендованном пакете */
  totalPublicationCount: number;
  /** Общее количество бонусов в рекомендованном пакете */
  totalAuctionPoints: number;
  /** Признак выбора пакета */
  selected: boolean;
  /** Сервисы в рекомендованном пакете */
  services: IRecommendedPackageService[];
  /** Тип пакета */
  type: EPackageType;
  /** Полигоны пакета */
  polygonIds: number[];
  /** Типы сделки для кастомного пакета */
  dealType: ECustomPackageDealType;
  /** Типы недвижимости для кастомного пакета */
  offerTypes: Array<ECustomPackageOfferType>;
  /** Тип рекомендуемого пакета */
  packageType: ERecommendedPackageType;
  /** Подарки */
  gifts: Array<IRecommendedPackageGift>;
  /** Точка покупки пакета/подписки */
  widgetSource: EBuyPackageSource;
}

export type TSelectedRecommendedPackageId = string | null;

export interface IRecommendedPackagesState {
  selectedPackageId: TSelectedRecommendedPackageId;
  packages: IRecommendedPackage[];
}

export enum ERecommendedPackageType {
  AllIn = 'allIn',
  Smb = 'smb',
  Custom = 'custom',
}

export enum EBuyPackageSource {
  LK = 'lk',
  AddForm = 'addForm',
  ServicePackageAdmin = 'servicePackageAdmin',
  SubscriptionAdmin = 'subscriptionAdmin',
  Mobile = 'mobile',
  Promocodes = 'promocodes',
  SmartPack = 'smartpack',
  AllIn = 'allIn',
  AddFormAllIn = 'addFormAllIn',
  AddFormSmartPack = 'addFormSmartPack',
}

export interface IRecommendedPackageGift {
  /** Иконка услуги */
  icon: string;
  /** Название услуги */
  name: string;
  /** Количество размещений на данную услугу */
  count: number;
  /** Срок размещения в днях **/
  durationInDays: number;
  /** Стоимость */
  price: number;
  /** Стоимость до скидки */
  marketingPrice: number;
}

export enum ERecommendedPackageGiftServiceType {
  /** Стандарт */
  Standard = 'standard',
  /** Платная публикация */
  Paid = 'paid',
  /** Премиум публикация */
  Premium = 'premium',
  /** Аукцион */
  Auction = 'auction',
  /** Топ */
  Top3 = 'top3',
  /** Публикация */
  Publication = 'publication',
}
